module.exports = __webpack_public_path__ + "components/page-footer/static/tide-forecast__logo--white-9992114e798c0bd4741b0f5ab793e794.png";